'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var polished = require('polished');

const WIDTH_XS = 'xs';
const WIDTH_SM = 'sm';
const WIDTH_MD = 'md';
const WIDTH_LG = 'lg';
const WIDTH_XL = 'xl';
const breakpointMinWidthsPx = {
  [WIDTH_XS]: 0,
  [WIDTH_SM]: 660,
  // Iphone landscape
  [WIDTH_MD]: 768,
  // Ipad portrait
  [WIDTH_LG]: 960,
  // Desktop
  [WIDTH_XL]: 1248 // Large destop / TV
};

const breakpointMinWidths = {
  [WIDTH_XS]: polished.rem(`${breakpointMinWidthsPx[WIDTH_XS]}px`),
  [WIDTH_SM]: polished.rem(`${breakpointMinWidthsPx[WIDTH_SM]}px`),
  [WIDTH_MD]: polished.rem(`${breakpointMinWidthsPx[WIDTH_MD]}px`),
  [WIDTH_LG]: polished.rem(`${breakpointMinWidthsPx[WIDTH_LG]}px`),
  [WIDTH_XL]: polished.rem(`${breakpointMinWidthsPx[WIDTH_XL]}px`)
};
const gridContainerMaxWidths = {
  [WIDTH_XS]: 'auto',
  [WIDTH_SM]: 'auto',
  [WIDTH_MD]: polished.rem('768px'),
  [WIDTH_LG]: polished.rem('960px'),
  [WIDTH_XL]: polished.rem('1248px')
};
const columns = 12;
const gutterHalfWidth = polished.rem('8px');

exports.WIDTH_LG = WIDTH_LG;
exports.WIDTH_MD = WIDTH_MD;
exports.WIDTH_SM = WIDTH_SM;
exports.WIDTH_XL = WIDTH_XL;
exports.WIDTH_XS = WIDTH_XS;
exports.breakpointMinWidths = breakpointMinWidths;
exports.breakpointMinWidthsPx = breakpointMinWidthsPx;
exports.columns = columns;
exports.gridContainerMaxWidths = gridContainerMaxWidths;
exports.gutterHalfWidth = gutterHalfWidth;
